























































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

@Component({})
export default class ImportCSVModalLayout extends Vue {
  @Prop()
  isOpenModal!: boolean

  @Prop({ default: () => ['field_1', 'field_2'] })
  csvFields!: string[]

  @Prop()
  storeActionName!: string

  @Prop({ default: null })
  paramsImport?: any

  @Prop({ default: null })
  errorMsg?: any

  csvFile: any = null

  @Watch('csvFile') onCSVFileChange() {
    this.$emit('update:errorMsg', null)
  }

  closeModal() {
    this.csvFile = null
    this.$emit('closeModal')
  }

  async handleImportCSV(): Promise<void> {
    const payload = !this.paramsImport ? this.csvFile : { file: this.csvFile, params: this.paramsImport }
    this.$store.dispatch(this.storeActionName, payload).then(resp => {
      this.$buefy.toast.open(this.$t('messages.save_success') as string)
      if (resp.errors && resp.errors.length) {
        this.$emit('update:errorMsg', resp.errors)
        return
      }
      this.closeModal()
    })
  }
}
